import { getIsLoggedIn } from '@/src/features/auth/utils/getIsLoggedIn'
import type { TSmallTagApi } from '@/src/features/tag/api/types/tagApi.types'
import { useRoutes } from '@/src/general/utils/routes'

import { CommunitiesSuggestionsSection } from './CommunitiesSuggestionsSection'
import { CurrentlyCommunitiesSection } from './CurrentlyCommunitiesSection'
import { FeaturedTagSlider } from './FeaturedTagSlider'
import { TeamFavoritesSection } from './TeamFavoritesSection'

type TCommunitiesSliderProps = { featuredTag?: TSmallTagApi }

export const CommunitiesSlider = ({ featuredTag }: TCommunitiesSliderProps) => {
  const { routes } = useRoutes()

  return (
    <>
      {getIsLoggedIn() && <CommunitiesSuggestionsSection />}

      {/* FEATURED TAG */}
      {featuredTag && <FeaturedTagSlider tag={featuredTag} link={routes.communitiesCategory(featuredTag.slug)} />}

      {/* CURRENTLY */}
      <CurrentlyCommunitiesSection hasFeaturedTag={!!featuredTag} />

      {/* TEAM FAVORITE */}
      <TeamFavoritesSection />
    </>
  )
}
